import {
  GetForm_vm_form as FormType,
  GetForm_vm_form_formItems_VOLUNTEER_FormItemFieldType_field as FormItemField,
} from '../__generated__/GetForm';
import {
  GetFormSubmissionsList,
  GetFormSubmissionsListVariables,
  GetFormSubmissionsList_vm_form_formSubmissions as FormSubmissionListItem,
  GetFormSubmissionsList_vm_form_formSubmissions_formFieldValues as FormFieldValue,
  GetFormSubmissionsList_vm_form_formItems_VOLUNTEER_FormItemFieldType as FormItemFieldType,
} from '../__generated__/GetFormSubmissionsList';
import {
  GetFormSubmission,
  GetFormSubmissionVariables,
  GetFormSubmission_vm_form_formSubmission as FormSubmissionDetail,
  GetFormSubmission_vm_form_formSubmission_formFieldValues as FormSubmissionFieldValue,
  GetFormSubmission_vm_form_formSubmission_comments as FormSubmissionComment,
  GetFormSubmission_vm_form_formSubmission_creations as FormSubmissionCreation,
} from '../__generated__/GetFormSubmission';
import {
  CreateRosterTemplateScreenGetProgramsAndActivities,
  CreateRosterTemplateScreenGetProgramsAndActivities_vm_programs as FormWizardProgram,
  CreateRosterTemplateScreenGetProgramsAndActivities_vm_activities as FormWizardActivity,
} from '../../../program-manager/rosters/roster-templates-screen/__generated__/CreateRosterTemplateScreenGetProgramsAndActivities';

// Re-export generated types
export type {
  FormType,
  FormSubmissionListItem,
  FormSubmissionDetail,
  FormFieldValue,
  FormSubmissionFieldValue,
  FormSubmissionComment,
  FormSubmissionCreation,
  FormItemFieldType,
  FormItemField,
  FormWizardProgram,
  FormWizardActivity,
  GetFormSubmissionsList,
  GetFormSubmissionsListVariables,
  GetFormSubmission,
  GetFormSubmissionVariables,
  CreateRosterTemplateScreenGetProgramsAndActivities,
};

// Derived types used across components
export interface FormFieldConfig {
  taskFieldId: string;
  name: string;
  fieldType: string;
  minValue?: number;
  maxValue?: number;
  minLabel?: string;
  maxLabel?: string;
  groupFormItemId?: string;
  groupTitle?: string;
  groupLabel?: string;
  formItemId?: string;
  depth?: number;
  optional?: boolean;
  triggeredByOptionName?: string;
}

export type FormOutlineNode =
  | {
      kind: 'page';
      formItemId: string;
      depth: number;
      title: string;
    }
  | {
      kind: 'heading';
      formItemId: string;
      depth: number;
      heading: string;
      triggeredByOptionName?: string;
    }
  | {
      kind: 'field';
      formItemId: string;
      depth: number;
      field: FormFieldConfig;
    }
  | {
      kind: 'group';
      formItemId: string;
      depth: number;
      title: string;
      label: string;
      fields: FormFieldConfig[];
      triggeredByOptionName?: string;
    };

export interface FormOutlineSection {
  key: string;
  heading?: { formItemId: string; heading: string };
  nodes: FormOutlineNode[];
}

export interface ExpandedFormFieldConfig extends FormFieldConfig {
  instanceIndex: number;
  expandedName: string;
}

export interface AvailableFormField {
  taskFieldId: string;
  name: string;
  fieldType?: string;
}

export type AdminFieldType = 'text' | 'number' | 'date';

export interface FormAdminField {
  adminFieldId: string;
  name: string;
  type: AdminFieldType;
  order: number;
}

export interface FormSubmissionAdminFieldValue {
  formSubmissionAdminFieldValueId: string;
  adminFieldId: string;
  name: string;
  type: AdminFieldType;
  value: string | null;
}

export interface ChartDataPoint {
  date: string;
  responses: number;
}

export interface FormFieldAggregate {
  answered: number;
  counts: Record<string, number>;
  respondents: Record<string, number>;
  samples: string[];
}

export type FormFieldAggregates = Record<string, FormFieldAggregate>;

export interface ExportSubmissionRow {
  formSubmissionId: string;
  submissionDate: string;
  submissionNumber: number | null;
  status: string | null;
  values: Array<{ taskFieldId: string; groupInstanceId: string | null; value: string }>;
  adminValues: Record<string, string>;
}

export interface ChoiceDataItem {
  name: string;
  fullName: string;
  count: number;
  percentage: number;
}

export interface NumericDataItem {
  name: string;
  count: number;
}

export interface TextItem {
  id: string;
  value: string;
}

// FieldAnalytics discriminated union
interface BaseFieldAnalytics {
  taskFieldId: string;
  name: string;
  fieldType: string;
  totalResponses: number;
  answeredCount: number;
  config?: Record<string, any>;
}

export interface ChoiceFieldAnalytics extends BaseFieldAnalytics {
  type: 'choice';
  data: ChoiceDataItem[];
}

export interface NumericFieldAnalytics extends BaseFieldAnalytics {
  type: 'numeric';
  avg: string;
  data: NumericDataItem[];
  scaleMin: number;
  scaleMax: number;
}

export interface TextFieldAnalytics extends BaseFieldAnalytics {
  type: 'text';
  items: TextItem[];
}

export interface ListFieldAnalytics extends BaseFieldAnalytics {
  type: 'list';
  items: TextItem[];
}

export interface SignatureFieldAnalytics extends BaseFieldAnalytics {
  type: 'signature';
}

export interface MatrixFieldAnalytics extends BaseFieldAnalytics {
  type: 'matrix';
  items: TextItem[];
}

export interface UnknownFieldAnalytics extends BaseFieldAnalytics {
  type: 'unknown';
  values: string[];
}

export type FieldAnalytics =
  | ChoiceFieldAnalytics
  | NumericFieldAnalytics
  | TextFieldAnalytics
  | ListFieldAnalytics
  | SignatureFieldAnalytics
  | MatrixFieldAnalytics
  | UnknownFieldAnalytics;

export type SortOrder = 'newest' | 'oldest';
export type EntityType = 'activity' | 'roster_template' | 'email' | 'calendar_invite' | 'applicant';

export const PAGE_SIZE = 25;
